import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getCategory, getKeyword } from '../selectors/app'
const mapStateToProps = createStructuredSelector({
  category: getCategory,
  keyword: getKeyword,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  category: string
  keyword: string
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect